// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__kk_js","buttons":"SendReceipts_buttons__2Q5tL","email":"SendReceipts_email__w0RAY","bookApptTitle":"SendReceipts_bookApptTitle__2S9RT"};